<template>
  <div class="flex items-center justify-end gap-4 border-t border-surface-200 px-4 py-2.5 text-xs text-surface-500">
    <span
      v-for="hint in hints"
      :key="hint.label"
      class="flex items-center gap-1.5"
    >
      <TwnKbd
        v-for="key in hint.keys"
        :key="key"
      >
        {{ key }}
      </TwnKbd>
      {{ hint.label }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { TwnPaletteKeyHintsProps } from '@/components/molecules/palette/twn-palette-key-hints/TwnPaletteKeyHints.types'

import TwnKbd from '@/components/atoms/typography/twn-kbd/TwnKbd.vue'

defineProps<TwnPaletteKeyHintsProps>()
</script>
